module.exports = __webpack_public_path__ + "media/PAG51-01.a1fa0032.mp3";